"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../Button"));
exports.ActionButton = react_1.default.forwardRef((props, ref) => {
    const color = props.highlight ? props.highlightColor || lib_palette_1.default.secondary : lib_palette_1.default.BlackCoral;
    return (react_1.default.createElement(Button_1.default, { ref: ref, classes: { root: props.big ? 'actionButtonBig' : 'actionButton' }, color: color, disabled: !!props.disabled, small: true, bordered: props.highlight, shadow: props.highlight, background: true, component: 'div', tooltip: props.tooltip, onClick: props.onClick, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }, !!props.Icon || !!props.children ? (react_1.default.createElement(Vertical_1.default, { centered: true },
        react_1.default.createElement("div", { className: "label" }, props.label),
        props.Icon && react_1.default.createElement(props.Icon, { size: 24 }),
        props.children)) : (props.label)));
});
exports.default = exports.ActionButton;
